'use client';
import { Modal } from '@curology/ui-components-web/react/Modal';
import { ModalContent } from '@curology/ui-components-web/react/Modal/ModalContent';
import { useAtom } from 'jotai';
import React from 'react';

import { LegalModalState } from '@/atoms/termsOfService/legalModalState';

export const LegalModal = () => {
  const [showLegalModal, setShowLegalModal] = useAtom(
    LegalModalState.showLegalModalAtom,
  );

  const [dataTestId] = useAtom(LegalModalState.legalModalDataTestIdAtom);
  const [src] = useAtom(LegalModalState.legalModalSrcAtom);
  const [title] = useAtom(LegalModalState.legalModalTitleAtom);

  const closeModal = () => {
    setShowLegalModal(false);
  };

  return (
    <Modal onClose={closeModal} open={showLegalModal}>
      <ModalContent>
        <div className="cur-bg-surface-neutral cur-flex cur-min-h-full md:cur-w-[768px]">
          <iframe
            data-test-id={dataTestId}
            src={`${src}?modal=true`}
            title={title}
            width="100%"
          />
        </div>
      </ModalContent>
    </Modal>
  );
};
